import styled from "styled-components";
import { NavLink as router } from "react-router-dom";

export const ContentNotification = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  @media (max-width: 600px) {
    margin: 0 10px;
  }
`;

export const ListNotification = styled.div`
  animation: animeTop 0.3s forwards;
  opacity: 0;
  transform: translateY(-20px);
  background: var(--secondary);
  border-radius: 5px;
  position: absolute;
  right: 170px;
  top: 90px;
  z-index: 3002;

  @media (max-width: 600px) {
    top: 105px;
    width: 100%;
    right: 0;
  }
  @keyframes animeTop {
    to {
      opacity: 1;
      transform: initial;
    }
  }
`;

export const Title = styled.h1`
  align-items: center;
  border-bottom: solid 1px #eee;
  color: #fff;
  display: flex;
  padding: 16px 24px;
`;

export const List = styled.ul`
  color: #fff;
`;

export const Item = styled(router)`
  display: grid;
  user-select: none;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  padding: 10px 25px;
  grid-gap: 0 8px;
  grid-template-columns: 50px auto;
  grid-template-rows: repeat(2, 1fr);
  transition: 0.4s all;
  border-bottom: solid 1px #eee;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: linear-gradient(
      to left,
      #d9dff8,
      #e4e7fa,
      #eeeefb,
      #f7f7fd,
      #f2f2f2
    );
    color: #000;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  background: var(--primary);
  justify-content: center;
  grid-column: 1 / 2;
  grid-row: 1 / 3;
`;

export const TitleItem = styled.h3`
  align-self: center;
  grid-column: 2 / 3;
`;

export const DescItem = styled.p`
  align-self: center;
  grid-column: 2 / 3;
`;

export const Construcao = styled.h1`
  padding: 15px;
`;

export const CleanNotification = styled.div`
  border-top: solid 1px #eee;
  display: flex;
  justify-content: center;
  padding: 10px 0px;
  width: 100%;
`;

export const ButtonCleanNotification = styled.button`
  background: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  color: #fff;
  &:hover {
    background: linear-gradient(
      to left,
      #d9dff8,
      #e4e7fa,
      #eeeefb,
      #f7f7fd,
      #f2f2f2
    );
    color: #000;
  }
  font-size: 1.4rem;
  padding: 5px;
  transition: 0.3s ease;
  text-transform: uppercase;
`;
